<template>
  <div class="orderCheckOut">
    <div class="backBox">
      <span class="tBack" @click="toBack">
        <van-icon name="arrow-left" />
      </span>
    </div>
    <!-- 添加 -->
    <div class="order_add_box" @click="toBuyerList">
      <div class="order_name">添加订单</div>
    </div>
    <!-- 刷新 -->

    <div class="order_refresh" @click="handleRefresh">
      <div v-show="showDot">
        <van-notice-bar mode="closeable">
          <template slot="right-icon">
            <div style="display:flex;align-items:center">
              <van-icon name="replay" />
              <!-- <span style="margin-left:0.1rem">刷新</span> -->
            </div>
          </template>
          您的订单发生变化,请及时更新!
        </van-notice-bar>
      </div>
      <div v-show="!showDot">
        <!-- <div class="red_dot" v-show="showDot"></div> -->
        <van-icon name="replay" />
        <span>刷新</span>
      </div>
    </div>
    <!-- 批次列表 -->
    <div class="order_list">
      <!-- 已添加的 -->
      <van-tabs
        ref="ref_tab_order"
        v-model="active_index"
        line-height="0"
        :border="false"
        color="transparent"
        background="transparent"
        @change="changeOrder"
      >
        <van-tab v-for="(item,index) in order_list" :key="index" :name="index">
          <template #title>
            <!-- <div class="order_name van-ellipsis">{{item.no | addZero}}</div>   -->
            <div class="order_name van-ellipsis">{{item.buyer_name}}</div>
          </template>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 订单里的商品 -->
    <div class="all_shop_box" v-if="order_list.length>0">
      <!-- 单个购物车 -->
      <div class="item_shop_box">
        <!-- 购物车box -->
        <div class="shop_box">
          <div
            class="shop_good checked"
            v-for="(item_good,index_good) in active_order"
            :key="index_good"
            @click="item_good.goods_status?'': changeNum(item_good)"
            v-show="item_good.goods_type != 0"
          >
            <!-- 采购员名字 -->
            <div class="staff_name">{{item_good.user_name}}</div>
            <!-- 商品名字和金额 -->
            <div v-if="item_good.goods_type == 1">
              <div class="shop_good_name_price">
                <div class>{{item_good.name}}</div>
                <div
                  v-if="item_good.bale == 1"
                >￥{{(Math.round(item_good.price * item_good.num * 100)/100).toFixed(2)}}</div>
                <div
                  v-else
                >￥{{(Math.round(item_good.price * item_good.weight * 100)/100).toFixed(2)}}</div>
              </div>
              <!-- 商品规格和数量 -->
              <div class="shop_good_type_num">
                <div class>
                  <div class="good_type good_type_0" v-if="item_good.bale == 3">
                    散装
                    <img src="./../../../assets/img/work/open_order/order/type_sanzhuang.png" alt />
                  </div>
                  <div class="good_type good_type_1" v-if="item_good.bale == 1">
                    定装
                    <img
                      src="./../../../assets/img/work/open_order/order/type_dingzhuang.png"
                      alt
                    />
                  </div>
                  <div class="good_type good_type_2" v-if="item_good.bale == 2">
                    非定装
                    <img
                      src="./../../../assets/img/work/open_order/order/type_feidingzhuang.png"
                      alt
                    />
                  </div>
                </div>
                <div
                  v-if="item_good.bale == 1"
                >{{item_good.num*1}}{{unit_list[item_good.num_unit-1].name}}x{{item_good.price}}元/{{unit_list[item_good.num_unit-1].name}}</div>
                <div v-else>{{Number(item_good.weight)}}公斤x{{item_good.price}}元/公斤</div>
              </div>
              <!-- 售罄 -->
              <div class="shop_num_no" v-if="item_good.goods_status">
                <img src="./../../../assets/img/work/manage/stock_saleoff.png" alt />
              </div>
            </div>
            <!-- 附加费 -->
            <div v-if="item_good.goods_type == 2">
              <div class="shop_good_name_price">
                <div class>{{item_good.name}}</div>
                <div>￥{{(Math.round(item_good.price * item_good.num * 100)/100).toFixed(2)}}</div>
              </div>
              <!-- 商品规格和数量 -->
              <div class="shop_good_type_num">
                <div class>
                  <div class="good_type good_type_3">
                    附加费
                    <img src="./../../../assets/img/work/open_order/order/type_fujiafei.png" alt />
                  </div>
                </div>
                <div>
                  {{item_good.price}}{{item_good.type == 1?'元/个':'元'}}
                  <span
                    v-if="item_good.type == 1"
                  >x {{item_good.num*1}}个</span>
                </div>
              </div>
            </div>
            <div class="shop_good_close" @click.stop="clearGoods(item_good)">
              <van-icon name="cross" size="0.24rem" />
            </div>
          </div>
        </div>
        <!-- 添加货品 -->
        <div class="add_shop_good" @click="toaddGoods">
          <van-icon name="plus" size="0.36rem" />
          <span style="margin-left:0.1rem">添加商品</span>
        </div>
        <!-- 删除该订单 -->
        <div class="romove_shop" @click="removeOrder()">
          <!-- 
          v-if="!(order_list.length == 1&& order_list[0].order_goods.length == 0)"-->
          <van-icon name="delete" size="0.36rem" />
          <span style="margin-left:0.1rem">删除该订单</span>
        </div>
        <div class="remakes shop_good" v-if="remakes&&remakes.length>0">
          <div class="staff_name">备注</div>
          <div>
            <div
              v-for="(desc_item,desc_index) in remakes"
              :key="desc_index"
            >{{desc_item.user_name}}:{{desc_item.desc}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 没有订单的话显示添加订单 -->
    <div class="all_shop_box" v-if="order_list.length == 0">
      <!-- 添加订单 -->
      <div style="height:0.8rem"></div>
      <div class="add_shop_good" @click="toBuyerList">
        <van-icon name="plus" size="0.36rem" />
        <span style="margin-left:0.1rem">添加订单</span>
      </div>
    </div>

    <!-- 底部结算栏 -->
    <div style="height:1.4rem"></div>
    <div v-if="order_list.length>0" class="order_footer" :disabled="total_goods_num==0">
      <div>
        <span>
          总计：
          <span class="color_theme">￥{{total_goods_amount}}</span>
        </span>
        <span>
          已选：
          <span class="color_theme">{{total_goods_num}}</span> 种
        </span>
      </div>
      <div class="order_footer_btn">
        <div @click="onPrint">打印</div>
        <div class="submit" @click="onSubmit">结算</div>
      </div>
    </div>

    <van-action-sheet
      v-model="showGoodsNum"
      :close-on-click-overlay="false"
      @closed="keyOnClose"
      @open="resetKey = true"
    >
      <div class="good_num_box" id="good_num_box" v-if="resetKey">
        <div class="good_title_box">
          {{input_active_goods.name}}
          <div>
            <div class="good_type good_type_0" v-if="input_active_goods.bale == 3">
              散装
              <img src="./../../../assets/img/work/open_order/order/type_sanzhuang.png" alt />
            </div>
            <div class="good_type good_type_1" v-if="input_active_goods.bale == 1">
              定装
              <img src="./../../../assets/img/work/open_order/order/type_dingzhuang.png" alt />
            </div>
            <div class="good_type good_type_2" v-if="input_active_goods.bale == 2">
              非定装
              <img src="./../../../assets/img/work/open_order/order/type_feidingzhuang.png" alt />
            </div>
            <div class="good_type good_type_3" v-if="input_active_goods.goods_type == 2">
              附加费
              <img src="./../../../assets/img/work/open_order/order/type_fujiafei.png" alt />
            </div>
          </div>
          <div class="good_box_close" @click="showGoodsNum = false">
            <van-icon name="cross" size="0.4rem" />
          </div>
        </div>
        <div class="good_content_box">
          <div class="good_item_wn" v-if="input_active_goods.goods_type == 1">
            <!-- 规格 -->
            <!-- <div class="good_item_input_box" v-if="input_active_goods.bale == 1">
              <KeyBoardInput :k_default_show="input_active_goods.bale == 1" :k_default_div="true" k_appendToId="good_num_box" v-model="keyData.bale_num" :k_placeholder="input_active_goods.bale_num" :k_decimal="3">
                <template slot="input_left">
                  <div class="input_left">规格</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">公斤/{{unit_list[input_active_goods.num_unit-1].name}}</div>
                </template>
              </KeyBoardInput>
            </div>-->
            <!-- 数量 -->
            <div
              class="good_item_input_box"
              v-if="input_active_goods.bale == 1 || input_active_goods.bale == 2"
            >
              <KeyBoardInput
                :k_default_show="input_active_goods.bale == 2 || input_active_goods.bale == 1"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.num"
                :k_placeholder="Number(input_active_goods.num)"
                :k_decimal="2"
              >
                <template slot="input_left">
                  <div class="input_left">数量</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">{{unit_list[input_active_goods.num_unit-1].name}}</div>
                </template>
              </KeyBoardInput>
            </div>
            <!-- 重量 -->
            <div
              class="good_item_input_box"
              v-if="input_active_goods.bale == 2 || input_active_goods.bale == 3"
            >
              <KeyBoardInput
                :k_default_show="input_active_goods.bale == 3"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.weight"
                :k_placeholder="input_active_goods.weight"
                :k_decimal="3"
              >
                <template slot="input_left">
                  <div class="input_left">重量</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">公斤</div>
                </template>
              </KeyBoardInput>
            </div>
            <!-- 单价 -->
            <div class="good_item_input_box">
              <KeyBoardInput
                :k_default_show="false"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.price"
                :k_placeholder="input_active_goods.price"
                :k_decimal="2"
              >
                <template slot="input_left">
                  <div class="input_left">单价</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">
                    <div
                      v-if="input_active_goods.bale == 1"
                    >元/{{unit_list[input_active_goods.num_unit-1].name}}</div>
                    <div v-if="input_active_goods.bale == 4">元/个</div>
                    <div v-if="input_active_goods.bale == 2 || input_active_goods.bale == 3">元/公斤</div>
                  </div>
                </template>
              </KeyBoardInput>
            </div>
          </div>
          <div class="good_item_wn" v-else>
            <div class="good_item_input_box" v-if="input_active_goods.type == 1">
              <KeyBoardInput
                :k_default_show="true"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.num"
                :k_placeholder="Number(input_active_goods.num)"
                :k_decimal="2"
              >
                <template slot="input_left">
                  <div class="input_left">数量</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">个</div>
                </template>
              </KeyBoardInput>
            </div>
            <div class="good_item_input_box" v-if="input_active_goods.type == 1">
              <KeyBoardInput
                :k_default_show="false"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.price"
                :k_placeholder="input_active_goods.price"
                :k_decimal="2"
                :k_isNegative="input_active_goods.price<0"
              >
                <template slot="input_left">
                  <div class="input_left">单价</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">元/个</div>
                </template>
              </KeyBoardInput>
            </div>
            <div class="good_item_input_box" v-if="input_active_goods.type != 1">
              <KeyBoardInput
                :k_default_show="true"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.price"
                :k_placeholder="input_active_goods.price"
                :k_decimal="2"
                :k_isNegative="input_active_goods.price<0"
              >
                <template slot="input_left">
                  <div class="input_left">金额</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">元</div>
                </template>
              </KeyBoardInput>
            </div>
          </div>
        </div>
        <!-- 使用一个假的键盘占个位置 -->
        <div class="fake_div">
          <div class="fake_confim">
            <button type="button" class="van-key van-key--large" @touchstart="keyOnConfirm">完成</button>
          </div>
          <div class="van-key__wrapper"></div>
          <van-number-keyboard
            style="position: relative;"
            :show="true"
            :transition="false"
            :extra-key="['AC','.']"
            close-button-text="完成"
            theme="custom"
            z-index="1"
          ></van-number-keyboard>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import KeyBoardInput from "@/components/KeyBoardInput";
import {
  shopCarCheckOut_open,
  shopCarCheckOut_getList,
  shopCarCheckOut_submit,
  shopCarCheckOut_getDetail,
  shopCarCheckOut_addGoods,
  shopCarCheckOut_deleteGoods,
  shopCarCheckOut_deleteOrder,
  shopCarCheckOut_checkGoods,
  shopCarCheckOut_updateGoods,
  uidAndMId,
  orderPrint,
  ws_url
} from "@/api/work/order/openOrder";
import Cookies from "@/utils/Cookies";
import { timestampToTime,longtimestampToTime } from "@/utils/timestamp.js";
export default {
  name: "orderCheckOut",
  components: {
    KeyBoardInput
  },
  filters: {
    addZero(num) {
      return (Array(4).join(0) + num).slice(-4);
    }
  },
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      order_active_index: 0,
      order_list: [],

      total_goods_num: 0,
      total_goods_amount: 0.0,

      active_order: [],
      active_sn: "",
      active_index: "",
      /**
       * 数字键盘功能
       */
      // 显示规格调整
      input_active_goods: "",
      showGoodsNum: false,
      keyValue: "",
      keyData: {
        id: "",
        weight: "",
        bale: "",
        // bale_num:"",
        num: "",
        price: ""
      },
      resetKey: true,
      ws: null, //长连接对象
      count: 0, //长连接次数
      t: null, //长连接的定时器
      showDot: false, //显示红点
      idGather: {},
      VNK: "",

      printLoading: true, // 打印按钮loading
      remakes: []
    };
  },
  created() {
    this.VNK = this.$route.query.VNK;
    // 获取已经添加的列表
    this.getOrderList();
    this.computeTotal();
    // 初始返回监听
    this.$navigation.on("back", (to, from) => {
      if (this.VNK == this.$route.query.VNK) {
        if (to.route.name == "openOrder_orderCheckOut") {
          // 结账
          if (
            from.route.name == "openOrder_orderPay" ||
            from.route.name == "openOrder_orderPayBack"
          ) {
            this.getOrderList(2, this.active_sn);
            this.computeTotal();
          }
          // 选择商品
          if (
            from.route.name == "openOrder_changeGoods" ||
            from.route.name == "openOrder_selectBatch"
          ) {
            if (from.route.meta.backData) {
              var goods = JSON.parse(from.route.meta.backData);
              this.addGoods(goods);
            }
          }
          // 添加订单
          if (
            from.route.name == "manage_buyer_buyerManage" &&
            from.route.meta.backData
          ) {
            var data = JSON.parse(JSON.stringify(from.route.meta.backData));
            this.addOrder(data);
          }
          this.computeTotal();
        }
      }
    });
    this.connection();
  },
  mounted() {},
  beforeDestroy() {
    let _this = this;
    _this.ws.onclose = function() {
      //  console.log("关闭")
      clearTimeout(_this.t);
    };
    _this.ws.onclose();
    clearTimeout(this.t);
  },
  methods: {
    //长连接
    connection() {
      let _this = this;
      _this.ws = new WebSocket(ws_url);

      _this.ws.onopen = function(e) {
        // console.log("链接成功")
        uidAndMId().then(res => {
          if (res.code == 200) {
            _this.idGather = res.data;

            let mes = JSON.stringify(_this.idGather);
            _this.ws.send(mes);
          }
        });
      };
      _this.ws.onclose = function(e) {
        _this.reconnection();
      };
      _this.ws.onerror = function() {
        _this.reconnection();
      };
      _this.ws.onmessage = function(res) {
        let data = JSON.parse(res.data);
        //  console.log(data)
        if (
          data.mid == _this.idGather.mid &&
          data.from_uid != _this.idGather.uid
        ) {
          _this.showDot = true;
        }
      };
    },
    //重连
    reconnection() {
      let _this = this;
      this.count = this.count + 1; // 1与服务器已经建立连接
      if (this.count >= 1000 || this.ws.readyState == 1) {
        clearTimeout(this.t);
      } else {
        // 2已经关闭了与服务器的连接
        if (this.ws.readyState == 3) {
          this.connection();
        } // 0正尝试与服务器建立连接,2正在关闭与服务器的连接
        this.t = setTimeout(function() {
          _this.reconnection();
        }, 100);
      }
    },
    // 切换批次
    changeOrder(i) {
      this.active_sn = this.order_list[i].main_sn;
      this.getOrderDetail();
    },
    // 刷新页面
    handleRefresh() {
      this.showDot = false;
      this.getOrderList(2, this.active_sn);
    },
    // 去选择买家
    toBuyerList() {
      this.$router.push({
        path: "/manage/buyer/buyerManage",
        query: {
          use_type: 1
        }
      });
    },
    // 添加一个订单
    addOrder(buyer_info) {
      shopCarCheckOut_open({ buyer_id: buyer_info.id })
        .then(res => {
          if (res.code == 200) {
            this.toaddGoods();
            this.active_index = 0;
            this.getOrderList(1, 0);
          }
        })
        .catch(err => {
          if (err.code == 201) {
            var sn = "";
            for (let i = 0; i < this.order_list.length; i++) {
              const item = this.order_list[i];
              if (item.buyer_id == buyer_info.id) {
                sn = item.main_sn;
                this.active_index = i;
                this.getOrderList(2, sn);
                break;
              }
            }
          }
        });
    },

    // 删除一个订单
    removeOrder() {
      if(this.total_goods_num>0){
        this.$dialog
          .confirm({
            title: "删除订单",
            message: "该订单内还有商品未结算，确认删除吗？"
          })
          .then(() => {
            shopCarCheckOut_deleteOrder({ main_sn: this.active_sn }).then(res => {
              if (res.code == 200) {
                this.getOrderList(1, this.active_index);
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      }else{
        shopCarCheckOut_deleteOrder({ main_sn: this.active_sn }).then(res => {
          if (res.code == 200) {
            this.getOrderList(1, this.active_index);
          }
        });
      }
    },

    // 获取订单列表 // type == 1 value = index ,type == 2 value = sn
    getOrderList(type = 1, value = 0) {
      shopCarCheckOut_getList().then(res => {
        if (res.code == 200) {
          this.showDot = false;
          // 如果列表有数据
          if (res.data.length > 0) {
            this.order_list = res.data;
            // 需要跳转的index
            if (type == 1) {
              this.changeOrder(value);
            } else {
              var i = this.checkSNinArray(value);
              if (i > -1) {
                this.active_index = i;
                this.changeOrder(i);
              } else {
                this.changeOrder(0);
              }
            }
          } else {
            this.order_list = [];
            this.active_order = [];
            this.active_sn = "";
          }
        }
      });
    },

    // 获取订单详情
    getOrderDetail() {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中...",
        loadingType: "spinner"
      });
      shopCarCheckOut_getDetail({ main_sn: this.active_sn }).then(res => {
        if (res.code == 200) {
          // var list = []
          // for (let i = 0; i < res.data.list.length; i++) {
          //   const item = res.data.list[i];
          //   if(item.goods_type != 0){
          //     list.push(item)
          //   }
          // }
          // this.active_order = list
          this.active_order = res.data.goods;
          this.remakes = res.data.desc;
          this.$toast.clear();
          this.computeTotal();
        }
      });
    },

    // 添加一个商品
    addGoods(goods) {
      var buyer_id = "";
      for (let i = 0; i < this.order_list.length; i++) {
        const item = this.order_list[i];
        if (this.active_sn == item.main_sn) {
          buyer_id = item.buyer_id;
        }
      }
      var subData = {
        buyer_id,
        main_sn: this.active_sn,
        goods: JSON.stringify(goods)
      };
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: "加载中..."
      });
      shopCarCheckOut_addGoods(subData).then(res => {
        if (res.code == 200) {
          this.$toast.clear();
          this.getOrderDetail(this.active_sn);
        }
      });
    },

    // 删除一件商品
    clearGoods(item) {
      var name = item.goods_type == 1 ? "商品 " : "附加费 ";
      this.$dialog
        .confirm({
          title: "删除" + name,
          message: "确认删除" + name + item.name + "吗？"
        })
        .then(() => {
          shopCarCheckOut_deleteGoods({ id: item.items_id }).then(res => {
            if (res.code == 200) {
              this.getOrderDetail(this.active_sn);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    // 打印
    onPrint() {
      this.computeTotal();
      if (this.total_goods_num == 0) {
        return false;
      }
      if (!this.printLoading) {
        this.$toast.success("正在打印中");
        return false;
      }
      var remakes_list = this.remakes;
      var remarks = "";
      if (remakes_list && remakes_list.length > 0) {
        for (let i = 0; i < remakes_list.length; i++) {
          const item = remakes_list[i];
          remarks += item.user_name + "：" + item.desc + "\n";
        }
      }
      this.printLoading = true;
      if (window.plus) {
        let userInfo = JSON.parse(Cookies.get("userInfo"));
        let shopInfo = JSON.parse(Cookies.get("shopInfo"));
        let plugins_data = {
          shop_name: shopInfo.shop_name,
          date: longtimestampToTime(new Date().getTime()),
          buyer_name: this.order_list[this.active_index].buyer_name,
          car_no: this.order_list[this.active_index].car_no,
          total_amount: this.total_goods_amount,
          casher: userInfo.realname,
          address: "",
          tel: userInfo.mobile,
          shop_goods: this.active_order
        };
        console.log(plugins_data)
        let result = plus.bridge.execSync("sunmiPrint", "printTempOrder", [
          JSON.stringify(plugins_data)
        ]);
        result = JSON.parse(result);
        if (result.code != 200) {
          orderPrint({
            goods: JSON.stringify(this.active_order),
            receivables: this.total_goods_amount,
            remarks
          }).then(res => {
            if (res.code == 200) {
               this.printLoading = false;
              this.$toast.success(res.message);
            }
          });
          return false;
        }else{
          this.$toast.success(res.msg);
          this.printLoading=false
        }
      }
      else{
         orderPrint({
            goods: JSON.stringify(this.active_order),
            receivables: this.total_goods_amount,
            remarks
          }).then(res => {
            if (res.code == 200) {
               this.printLoading = false;
              this.$toast.success(res.message);
            }
          });
      }
    },

    // 结账
    onSubmit() {
      this.computeTotal();
      var order_detail = {};
      var goods = [];
      for (let i = 0; i < this.active_order.length; i++) {
        const item = this.active_order[i];
        item.sn = this.active_sn;
        goods.push(item);
      }
      order_detail.buyer_id = this.active_order[0].buyer_id;
      order_detail.buyer_name = this.active_order[0].buyer_name;
      var order_good = [];
      for (let i = 0; i < goods.length; i++) {
        const im = goods[i];
        if (im.goods_type == 1 || im.goods_type == 2) {
          order_good.push(im);
        }
      }
      order_detail.order_goods = order_good;
      if (order_good.length == 0) {
        return false;
      }
      shopCarCheckOut_checkGoods({
        main_sn: this.active_sn,
        goods: JSON.stringify(goods)
      })
        .then(res => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              this.$toast(res.message);
              this.handleRefresh();
            } else {
              var car_no = ''
              for (let w = 0; w < this.order_list.length; w++) {
                const item = this.order_list[w];
                if(item.main_sn == this.active_sn){
                  car_no = item.car_no
                }
              }
              if (this.total_goods_amount < 0) {
                this.$router.push({
                  path: "/openOrder/orderPayBack",
                  query: {
                    type: 1, // type == 1 开单, type == 2 改单, type == 3 补单
                    item: encodeURI(JSON.stringify(order_detail)),
                    remakes: JSON.stringify(this.remakes),
                    main_sn: this.active_sn,
                    car_no,
                  }
                });
              } else {
                this.$router.push({
                  path: "/openOrder/orderPay",
                  query: {
                    type: 1, // type == 1 开单, type == 2 改单, type == 3 补单
                    item: encodeURI(JSON.stringify(order_detail)),
                    remakes: JSON.stringify(this.remakes),
                    main_sn: this.active_sn,
                    car_no,
                  }
                });
              }
            }
          }
        })
        .catch(err => {});
    },

    // 判断 这个 sn 是否还在order_list 里
    checkSNinArray(sn) {
      var flag = -1;
      for (let i = 0; i < this.order_list.length; i++) {
        const item = this.order_list[i];
        if (item.main_sn == sn) {
          flag = i;
        }
      }
      return flag;
    },

    // 计算总价
    computeTotal() {
      if (this.order_list.length > 0) {
        var goods = this.active_order;
        var amount = 0;
        var num = 0;
        for (let i = 0; i < goods.length; i++) {
          const item = goods[i];
          if (item.goods_type == 1) {
            num++;
            if (item.bale == 1) {
              amount += Math.round(item.price * item.num * 100) / 100;
            } else {
              amount += Math.round(item.price * item.weight * 100) / 100;
            }
          } else if (item.goods_type == 2) {
            num++;
            amount += Math.round(item.price * item.num * 100) / 100;
          }
        }
        this.total_goods_num = num;
        this.total_goods_amount = amount.toFixed(2);
      }
    },

    // 去选择商品
    toaddGoods() {
      this.$router.push({
        path: "/openOrder/selectBatch"
      });
    },
    toBack() {
      this.$router.replace({
        path: "/home"
      });
    },
    /**
     * 修改规格相关
     */
    changeNum(good) {
      this.input_active_goods = JSON.parse(JSON.stringify(good));
      this.keyData.id = this.input_active_goods.id;
      // this.keyData.weight = good.weight +''
      // this.keyData.bale_num = good.bale_num +''
      // this.keyData.bale = good.bale +''
      // this.keyData.num = good.num +''
      // this.keyData.price = good.price +''
      this.showGoodsNum = true;
    },
    // 完成
    keyOnConfirm() {
      var good = this.input_active_goods;
      this.keyData.weight =
        this.keyData.weight === "" ? good.weight + "" : this.keyData.weight;
      this.keyData.bale = good.bale;
      this.keyData.num =
        Number(this.keyData.num === "" ? good.num + "" : this.keyData.num) + "";
      this.keyData.price =
        this.keyData.price === "" ? good.price + "" : this.keyData.price;

      if (this.input_active_goods.bale == 1 && !(this.keyData.num > 0)) {
        this.$toast("请输入商品销售数量！");
        return false;
      }
      if (this.input_active_goods.bale == 2 && !(this.keyData.num > 0)) {
        this.$toast("请输入商品销售数量！");
        return false;
      }
      if (this.input_active_goods.bale == 2 && !(this.keyData.weight > 0)) {
        this.$toast("请输入商品销售重量！");
        return false;
      }
      if (this.input_active_goods.bale == 3 && !(this.keyData.weight > 0)) {
        this.$toast("请输入商品销售重量！");
        return false;
      }
      if (
        this.input_active_goods.goods_type == 2 &&
        this.input_active_goods.type == 1 &&
        !(this.keyData.num > 0)
      ) {
        this.$toast("请输入附加费数量！");
        return false;
      }
      if (this.keyData.price == 0 && this.input_active_goods.goods_type == 1) {
        this.$toast("请输入商品单价！");
        return false;
      }
      let i = this.input_active_order_index,
        i_g = this.input_active_goods_index;
      if (this.input_active_goods.bale == 1) {
        this.keyData.weight = Number(
          (Number(this.keyData.num) * Number(good.bale_num)).toFixed(3)
        );
      } else {
        this.keyData.weight = Number(this.keyData.weight);
      }

      var keyData = JSON.parse(JSON.stringify(this.keyData));
      keyData.price =
        good.price < 0 && keyData.price > 0
          ? -this.keyData.price
          : this.keyData.price;

      var t_price = 0;
      if (this.input_active_goods.goods_type == 1) {
        if (this.input_active_goods.bale == 1) {
          t_price = (keyData.price * keyData.num).toFixed(2);
        } else {
          t_price = (keyData.price * keyData.weight).toFixed(2);
        }
      } else {
        if (this.input_active_goods.type == 1) {
          t_price = (keyData.price * keyData.num).toFixed(2);
        } else {
          t_price = (keyData.price * 1).toFixed(2);
        }
      }
      new Audio(
        "http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=" +
          this.input_active_goods.name +
          "，" +
          t_price +
          "元"
      ).play();
      var input_active_goods_copy = JSON.parse(
        JSON.stringify(this.input_active_goods)
      );
      input_active_goods_copy.weight = keyData.weight;
      input_active_goods_copy.num = keyData.num;
      input_active_goods_copy.price = keyData.price;
      var s_data = {
        id: this.input_active_goods.items_id,
        items_sn: this.input_active_goods.items_sn,
        goods: JSON.stringify(input_active_goods_copy)
      };
      shopCarCheckOut_updateGoods(s_data).then(res => {
        if (res.code == 200) {
          this.getOrderDetail(this.active_sn);
          this.showGoodsNum = false;
        }
      });
    },
    // 关闭事件
    keyOnClose() {
      this.keyData = {
        id: "",
        weight: "",
        bale: "",
        num: "",
        price: ""
      };
      this.resetKey = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "home" || to.name == "homeStaff") {
      this.$navigation.off("back");
    }
    next(); //一定不要忘记写
  }
};
</script>

<style lang="less" scoped>
.orderCheckOut {
  position: relative;
  // 键盘
  .good_num_box {
    position: relative;
    background-color: #f2f3f5;
    .good_title_box {
      font-size: 0.36rem;
      line-height: 0.6rem;
      padding: 0.2rem 0.5rem;
      color: #333;
      font-weight: bold;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      div {
        font-size: 0.28rem;
        color: #999;
        font-weight: normal;
        margin-left: 0.1rem;
      }
      .good_box_close {
        position: absolute;
        right: 0.3rem;
        top: 0.2rem;
        z-index: 2;
      }
    }
    .good_content_box {
      padding: 0 0.3rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .good_item_wn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
      }
      .good_item_input_box {
        width: 100%;
        height: 0.88rem;
        line-height: 0.84rem;
        border: 0.02rem solid #ccc;
        padding: 0 0.15rem;
        margin-bottom: 0.2rem;
        box-sizing: border-box;
        border-radius: 0.1rem;
        .good_item_input {
          flex: auto;
          overflow: hidden;
          height: 0.84rem;
          margin: 0 0.1rem;
          padding-right: 0.05rem;
          position: relative;
          text-align: right;
          font-size: 0.32rem;
          font-weight: bold;
          background-color: transparent;
        }
      }
    }
  }

  .good_type {
    padding: 0 0.18rem;
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0.2rem;
    &.good_type_0 {
      background-color: #dafbdb;
      color: #4b9c64;
    }
    &.good_type_1 {
      background-color: #daeffb;
      color: #1d78c5;
    }
    &.good_type_2 {
      background-color: #fbedda;
      color: #bf8535;
    }
    &.good_type_3 {
      background-color: #fbe1da;
      color: #bf1535;
    }
    img {
      width: 0.22rem;
      height: 0.22rem;
      margin-left: 0.1rem;
    }
  }
  .fake_div {
    position: relative;
    .fake_confim {
      position: absolute;
      right: 6px;
      z-index: 999;
      bottom: 6px;
      width: calc((100% - 6px) / 4 - 6px);
      height: calc(50% - 12px);
      background-color: #31b158;
      border-radius: 8px;
      button {
        background-color: #31b158;
        color: #fff;
        font-size: 0.42rem;
      }
    }
  }

  .backBox {
    display: flex;
    align-items: center;
    .tBack {
      width: 0.4rem;
      padding: 0 0.2rem;
      position: fixed;
      left: 0.02rem;
      top: 0.3rem;
      z-index: 100;
    }
  }
  // 键盘结束
  .order_add_box {
    position: fixed;
    height: 0.88rem;
    // line-height: 0.88rem;
    text-align: center;
    right: 0.3rem;
    top: 0;
    z-index: 10;
    font-size: 0.3rem;
    font-weight: 500;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div {
      padding: 0 0.2rem;
      line-height: 0.54rem;
      border: 0.01rem solid #31b158;
      border-radius: 0.28rem;
      background-color: #31b158;
      color: #fff;
    }
  }

  .order_refresh {
    width: 100%;
    position: fixed;
    top: 1.06rem;
    z-index: 4;
    right: 0.5rem;
    top: 0.88rem;
    right: 0;
    color: #fff;
    font-size: 0.28rem;
    display: flex;
    align-items: center;
    & > div:nth-child(1) {
      width: 100%;
    }
    & > div:nth-child(2) {
      margin: 0.2rem 0 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      padding-right: 0.3rem;
      box-sizing: border-box;
      height: 0.28rem;
      span {
        margin-left: 0.1rem;
      }
    }

    // .red_dot {
    //   border: 1px solid #ffffff;
    //   position: absolute;
    //   right: 0;
    //   top: 0;
    //   transform: translate(100%, -50%);
    //   width: 8px;
    //   height: 8px;
    //   background: #ee0a24;
    //   border-radius: 50%;
    // }
    // span {
    //   margin-left: 0.1rem;
    // }
  }
  .order_list {
    position: sticky;
    z-index: 2;
    top: 0.88rem;
    width: 100%;
    height: 1.72rem;
    padding-top: 0.72rem;
    // background: linear-gradient(-90deg, #25a94d, #3fbe66);
    background: url(./../../../assets/img/layout/home/bg.png) no-repeat center
      bottom;
    background-size: 100%;
    box-sizing: border-box;
    overflow: hidden;
    .order_items {
      width: 5.6rem;
      height: 1rem;
      white-space: nowrap;
      overflow-y: hidden;
      overflow-x: auto;
      &::before {
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
      }
      .order_item {
        line-height: 1rem;
        margin-right: 0.16rem;
        &:nth-child(1) {
          margin-left: 0.3rem;
        }
      }
    }
  }

  // 中间模块
  .shop_box {
    padding: 0.3rem 0.2rem 0;
    .shop_good {
      width: 6.9rem;
      margin: 0 auto 0.2rem;
      height: 1.5rem;
      border-radius: 0.1rem;
      background-color: #fff;
      border: 0.02rem solid #fff;
      overflow: hidden;
      position: relative;
      padding: 0 0.3rem;
      padding-left: 0.8rem;
      box-sizing: border-box;
      &.checked {
        border: 0.02rem solid #31b158;
        .shop_good_close {
          display: flex;
        }
      }
      .staff_name {
        width: 0.5rem;
        height: 100%;
        position: absolute;
        background-color: #e5e5e5;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333333;
        font-size: 0.28rem;
        top: 0;
        left: 0;
        font-weight: 500;
      }
      .shop_good_name_price,
      .shop_good_type_num {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .shop_good_name_price {
        font-size: 0.36rem;
        color: #333;
        font-weight: bold;
        margin-top: 0.24rem;
      }
      .shop_good_type_num {
        font-size: 0.28rem;
        color: #666;
        margin-top: 0.12rem;
      }
      .shop_num_no {
        position: absolute;
        right: 3.3rem;
        top: 0.3rem;
        z-index: 4;
        img {
          width: 1rem;
          height: 1rem;
        }
      }

      .shop_good_close {
        position: absolute;
        right: 0;
        top: 0;
        width: 0.28rem;
        height: 0.28rem;
        background-color: #31b158;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        display: none;
      }
    }
  }
  // 添加货品
  .add_shop_good {
    width: 6.9rem;
    margin: 0 auto 0.2rem;
    height: 1.5rem;
    border-radius: 0.1rem;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.36rem;
    color: #31b158;
    font-weight: bold;
  }

  // 删除订单
  .romove_shop {
    background-color: #fb8a8a;
    width: 6.9rem;
    border-radius: 0.1rem;
    height: 0.8rem;
    margin: 0 auto 0.2rem;
    margin-top: 0.6rem;
    font-size: 0.36rem;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // 备注
  .remakes {
    position: relative;
    width: 6.9rem;
    margin: 0 auto 0.2rem;
    min-height: 1.2rem;
    border-radius: 0.1rem;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.32rem;
    color: #333;
    padding: 0.1rem 0.2rem;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: hidden;
    color: #333;
    padding-left: 0.5rem;
    & > div:nth-child(1) {
      width: 0.5rem;
      height: 100%;
      position: absolute;
      background-color: #e5e5e5;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333333;
      font-size: 0.28rem;
      top: 0;
      left: 0;
      font-weight: 500;
    }
    & > div:nth-child(2) {
      width: 6rem;
      padding-left: 0.15rem;
      border-left: 0.01rem solid #e1e1e1;
    }
    textarea {
      width: 5.8rem;
      height: 100%;
      outline: none;
      border: none;
      resize: none;
    }
  }

  // 底部
  .order_footer {
    width: 100%;
    height: 1.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0rem -0.1rem 0.2rem 0.05rem rgba(191, 191, 191, 0.1);
    &[disabled] {
      & > div:nth-child(1) {
        & > span {
          color: #b3b3b3 !important;
          .color_theme {
            color: #b3b3b3 !important;
          }
        }
      }
      .order_footer_btn > div {
        background-color: #b3b3b3 !important;
        color: #fff !important;
        border: transparent !important;
      }
    }
    & > div:nth-child(1) {
      & > span {
        display: block;
        margin-left: 0.2rem;
        font-size: 0.36rem;
        color: #333;
        font-weight: bold;
        &:nth-child(2) {
          margin-top: 0.1rem;
          font-size: 0.28rem;
        }
        .color_theme {
          color: #31b158;
          font-size: 0.36rem;
        }
      }
    }
    .order_footer_btn {
      display: flex;
      align-items: center;
      & > div {
        width: 1.6rem;
        height: 0.8rem;
        background-color: #31b158;
        color: #fff;
        font-size: 0.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        margin-right: 0.1rem;
        border-radius: 0.08rem;
        &:nth-child(1) {
          border: 0.01rem solid #eea10b;
          background: #fff;
          color: #eea10b;
          // margin-right: 0.05rem;
        }
      }
    }
  }
}
</style>

<style lang="less">
.orderCheckOut {
  .van-tabs {
    width: 100%;
    // padding-right: 1.9rem ;
    height: 1rem;
    .van-tabs__wrap {
      height: 1rem;
      // line-height: 1rem;
      .van-tabs__nav {
        box-sizing: border-box;
        .van-tab {
          box-sizing: border-box;
          width: 1.6rem;
          min-width: 1.6rem;
          height: 1rem;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 0.1rem 0.1rem 0px 0px;
          font-size: 0.32rem;
          color: #fff;
          padding: 0 0.1rem;
          // line-height: 1rem;
          margin-right: 0.2rem;
          flex: inherit;
          &:nth-child(1) {
            margin-left: 0.2rem;
          }
          .order_num {
            font-size: 0.28rem;
            line-height: 0.38rem;
          }
          .order_name {
            font-weight: bold;
            letter-spacing: -0.01rem;
          }
          &--active {
            background: #f5f5f5;
            color: #333;
            .order_num {
              color: #999999;
            }
          }
        }
      }
    }
    .van-tab:last-child {
      font-size: 0.6rem;
      margin-right: 1rem;
    }
  }
  .van-notice-bar {
    height: 28px;
  }
}
</style>